var RichTextTableResponsive = (function () {
  

  function init() {
    var $richTextTables = $('.rzf-gry-rich-text table');

    if ($richTextTables.length > 0) {
      $richTextTables.each(function () {
        var headerLabels = [];

        // gather headers and store them in the array
        $(this).find('thead tr th').each(function (index, value) {
          headerLabels.push(value.innerHTML);
        });

        // gather rows
        var tableRows = $(this).find('tbody > tr');

        // loop through each row
        tableRows.each(function () {
          var tableCells = $(this).children('td');

          // assign data-label to each table cell in the current row
          tableCells.each(function (index) {
            $(this).attr('data-label', headerLabels[index]);
          });
        });

        /* $(this).find('tbody > tr > td').each(function(index, value) {
          console.log('this: ', $(this));
          console.log('index: ', index);

          $(this).attr('data-label', headerLabels[index]);
        }); */
      });
    }
  }

  return {
    init: init,
  };
}());
